import { IAdLazyLoadConf, IAdRefreshConf } from '../../../services/ads/ad'
import {
    IAdBiddingProviderConfig
} from '../../../services/ads/adapters'
import { IProviderConfig } from '../../../services/common/provider-config'
import { Entity, IEntity } from '../../entity'

export interface IAdsConfiguration {
    /**
     * Network key; e.g. 'ccn'; default is 'print'
     */
    network?: string

    /**
     * Property; e.g. 'np'
     */
    property: string
    provider: IProviderConfig

    /**
     * Refresh settings.
     */
    refresh?: boolean | IAdRefreshConf

    /**
     * Lazy load settings.
     */
    lazy?: boolean | IAdLazyLoadConf

    /**
     * Ad site; e.g. 'npo_ind'
     */
    site: string

    /**
     * Configure how ads appear in comments
     */
    commentAdConfiguration?: ICommentAdConfiguration

    /**
     * Whether Browsi is integrated in the page
     */
    browsiIntegration?: boolean

    /**
     * What percentage of pages to display Browsi configuration (for A/B testing)
     */
    browsiPercentage?: number

    /**
     * Configure the sticky mobile ad
     */
    stickyAd?: IAdMobileStickyConfiguration
}

export interface IAdBiddingConfiguration extends IAdsConfiguration {
    bidding: IAdBiddingProviderConfig[]
}

export interface IAdVerifierConfiguration extends IAdsConfiguration {
    verifier: IProviderConfig
}

export interface IAdMobileStickyConfiguration extends IEntity {
    enabled: boolean
    bottom: boolean
    close: boolean
    closeTimer: number
    pageTargeting: string[]
}
export interface ICommentAdConfiguration extends IEntity {
    firstPromoPosition: string
    promoInterval: string
}

export class AdsConfiguration extends Entity
    implements IAdsConfiguration, IAdBiddingConfiguration, IAdVerifierConfiguration {

    public bidding: IAdBiddingProviderConfig[]
    public network?: string
    public property: string
    public provider: IProviderConfig
    public refresh?: boolean | IAdRefreshConf
    public lazy?: boolean | IAdLazyLoadConf
    public site: string
    public verifier: IProviderConfig
    public commentAdConfiguration?: ICommentAdConfiguration
    public browsiIntegration?: boolean
    public browsiPercentage?: number
    public stickyAd?: IAdMobileStickyConfiguration

    public fromJson(jsonObject: object): IAdsConfiguration {
        super.fromJson(jsonObject)

        // parse provider objects
        this.provider = (jsonObject as this).provider
        if ((jsonObject as this).bidding) {
            this.bidding = (jsonObject as this).bidding
        }
        if ((jsonObject as this).verifier) {
            this.verifier = (jsonObject as this).verifier
        }

        // parse refresh
        if ((jsonObject as this).refresh) {
            this.refresh = (jsonObject as this).refresh
        }

        // parse lazy
        if ((jsonObject as this).lazy) {
            this.lazy = (jsonObject as this).lazy
        }

        // parse commentAdConfiguration
        if ((jsonObject as this).commentAdConfiguration) {
            this.commentAdConfiguration = (jsonObject as this).commentAdConfiguration
        }

        // parse Browsi settings
        if ((jsonObject as this).browsiIntegration) {
            this.browsiIntegration = (jsonObject as this).browsiIntegration
        }
        if ((jsonObject as this).browsiPercentage) {
            this.browsiPercentage = (jsonObject as this).browsiPercentage
        }

        // parse sticky mobile ad settings
        if ((jsonObject as this).stickyAd) {
            this.stickyAd = (jsonObject as this).stickyAd
        }

        return this
    }
}
